// Generated by IcedCoffeeScript 1.7.1-c
(function () {
  exports.Generator = require('../lib/generator').Generator;
}).call(this);